<!--
  DecorationLifecycleChip.vue -- ADR 0056 (per-store Decorations tab).

  Renders one of the 8 canonical lifecycle-state chips (see
  ../decorationLifecycle.js for the vocabulary table). Used both on
  each decoration row (state-in-context) and in the "How decorations
  work" explainer's full 8-chip legend (data-testid-override switches
  the testid so both usages stay independently selectable per the
  project's data-testid convention).

  Per the design handoff, label/color/icon are final intent -- pulled
  straight from decorationLifecycle.js so there is exactly one source
  for the chip vocabulary (no risk of a second copy drifting).
-->
<template>
  <span
    class="dlc"
    :class="{ 'dlc--sm': size === 'sm' }"
    :style="{ background: chip.bg, color: chip.fg }"
    :data-testid="testId"
    :data-lifecycle-state="state"
  >
    <span class="tf-icon dlc__icon">{{ chip.icon }}</span>
    {{ chip.label }}
  </span>
</template>

<script>
import { chipFor } from "../decorationLifecycle";

export default {
  name: "DecorationLifecycleChip",
  props: {
    state: { type: String, required: true },
    size: { type: String, default: "md" },
    // Optional testid override so the same component can be
    // distinguished when rendered in different contexts (a per-row
    // chip vs. the "How decorations work" legend's full 8-chip set).
    dataTestidOverride: { type: String, default: "" },
  },
  computed: {
    chip() {
      return chipFor(this.state);
    },
    testId() {
      return this.dataTestidOverride || "decoration-lifecycle-chip";
    },
  },
};
</script>

<style scoped>
.dlc {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 9px 3px 7px;
  border-radius: 9999px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
}
.dlc--sm {
  font-size: 10px;
  padding: 2px 8px 2px 6px;
}
.dlc__icon {
  font-size: 12px;
}
.dlc--sm .dlc__icon {
  font-size: 11px;
}
</style>
